export const name = "ABS";
export const summary = `Computes the absolute value of \`X\`.`;
export const reference = `
## ABS

Computes the absolute value of \`X\`.

\`\`\`
ABS(X)
\`\`\`

### Description

Computes absolute value. Returns an error if the argument is an integer and the output value can't be represented as the same type; this happens only for the largest negative input value, which has no positive representation.

| X | ABS(X) |
| --- | --- |
| 25 | 25 |
| -25 | 25 |
| \`+inf\` | \`+inf\` |
| \`-inf\` | \`+inf\` |


### Return Data Type

| INPUT | \`INT64\` | \`NUMERIC\` | \`BIGNUMERIC\` | \`FLOAT64\` |
| --- | --- | --- | --- | --- |
| OUTPUT | \`INT64\` | \`NUMERIC\` | \`BIGNUMERIC\` | \`FLOAT64\` |


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
